import { useMutation } from "react-query"
import api from "../client"
import { queryClient, queryKeys } from "../query"
import { UpdateOrderCalculationResponseData, UpdateOrderUnloadingPaylod } from "../types/order"

const patchData = async (uuid: string | undefined, payload: UpdateOrderUnloadingPaylod) => {
    const { data } = await api.patch<UpdateOrderCalculationResponseData>(
        `/orders/${uuid}`,
        payload
    )

    queryClient.invalidateQueries(queryKeys.ORDER(uuid))
    queryClient.invalidateQueries(queryKeys.ORDER_SUMMARY(uuid), { refetchInactive: true })
    queryClient.invalidateQueries(["orders"], { refetchInactive: true })

    return data
}

export const useUpdateUnloading = (uuid: string | undefined) => {
    return useMutation((payload: UpdateOrderUnloadingPaylod) => {
        return patchData(uuid, payload)
    })
}
